var _defs, _rect, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCp2StickerOvalIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b,.f{fill:#3c3c46;}.b{opacity:0.15;}.c{fill:#3ca4ef;}.c,.d,.e,.g{stroke:#3c3c46;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.d{fill:#ffefe0;}.d,.e,.f,.g{fill-rule:evenodd;}.e{fill:#89d9fb;}.f{opacity:0.2;}.g{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CP-sticker-oval-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 140,
    height: 140
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 75,
    cy: 82,
    rx: 50.05,
    ry: 35.58,
    transform: "translate(-30.95 48.48) rotate(-30)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 67,
    cy: 76,
    rx: 50.05,
    ry: 35.58,
    transform: "translate(-29.02 43.68) rotate(-30)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 69,
    cy: 70,
    rx: 50.05,
    ry: 35.58,
    transform: "translate(-25.76 43.88) rotate(-30)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 65,
    cy: 64,
    rx: 50.05,
    ry: 35.58,
    transform: "translate(-23.29 41.07) rotate(-30)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M69.48,19.43h.06C87,15.93,103.26,20.69,110.35,33c4.67,8.09,4.53,18,.53,27.63l-.07.16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M49.21,27.19a67.23,67.23,0,0,1,20.27-7.75l41.33,41.33c-4.44,10.58-13.53,20.84-26,28.05C60.85,102.64,33.48,100,23.65,83S25.27,41,49.21,27.19Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M49.21,27.19a67.23,67.23,0,0,1,20.27-7.75l41.33,41.33c-4.44,10.58-13.53,20.84-26,28.05C60.85,102.64,33.48,100,23.65,83S25.27,41,49.21,27.19Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M100.83,67.08C82.89,74.93,68.35,62.94,68.35,40.3a59.46,59.46,0,0,1,1.56-13.25v0l40.89,33.72-.13.11A41.08,41.08,0,0,1,100.83,67.08Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M69.48,19.43v.06C66,37,70.74,53.21,83,60.3c8.09,4.67,18,4.53,27.63.53l.16-.07Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCp2StickerOvalIcon);
export default __webpack_public_path__ + "static/media/CP2-sticker-oval-icon.43ca41ad6a6b4cccd085d9a2b3513ef2.svg";
export { ForwardRef as ReactComponent };